import { FC, ReactElement, useState } from 'react'
import UserVote from 'components/UserVote'
import StarRatings from 'react-star-ratings'
import styled, { useTheme } from 'styled-components'

interface HeaderProps {
  id?: string
  authorRating: number
}

const Rating: FC<HeaderProps> = ({id, authorRating}): ReactElement => {
  const theme = useTheme() as any
  const [audienceRateCount, setAudienceRateCount] = useState(-1)

  return (
    <Container>
      <b>Notre critique</b>
      <StarRatings
        rating={authorRating !== null ? authorRating : 0}
        starRatedColor={`var(--tenant-${theme.tenant.key.slice(0, 3)})`}
        starEmptyColor='var(--site-background)'
        svgIconPath='M24 1.175l7.553 14.84L48 18.611 36.22 30.38l2.613 16.444L24 39.26 9.167 46.825 11.78 30.38 0 18.613l16.447-2.598z'
        starDimension='20px'
        starSpacing='3px'
        numberOfStars={5}
        name='author-rating'
      />
      <span>
        <b>Public</b> ({audienceRateCount})
      </span>
      <UserVote
        handleUpdateRatingCount={(votes) => {
          setAudienceRateCount(votes)
        }}
        tippId={id || ''}
      />
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  font-family: var(--font-plex);
  font-size: 1.5rem;
  border-top: 1px solid #d4d4d4;
  padding-top: 2rem;
  line-height: normal;
  grid-gap: 1rem;
  grid-row-gap: 0.25rem;
`

export default Rating
